import api from '../Api/api';
import { SUPPORT_SUMMARY, SUPPORT_TICKETS } from '../Api/URLS';

// Support tickets (allern-admin-backend /admin/support/*). Every response is
// { success, message?, data } or, on error, { success: false, status, message }.

const getSupportSummary = () => api.get(SUPPORT_SUMMARY);

// params: { status, category, q, unreadOnly, assignedTo ('me' | 'none' | userId), page (0-based), size }
const getSupportTickets = (params) => api.get(SUPPORT_TICKETS, { params });

// Opening a ticket clears its "awaiting support" flag.
const getSupportTicket = (ticketId) => api.get(`${SUPPORT_TICKETS}/${ticketId}`);

// Text and/or up to 2 files; closeTicket closes it in the same step.
const replySupportTicket = (ticketId, message, files, closeTicket) => {
  const formData = new FormData();
  if (message) formData.append('message', message);
  (files || []).forEach((file) => formData.append('files', file));
  formData.append('closeTicket', closeTicket ? 'true' : 'false');
  return api.post(`${SUPPORT_TICKETS}/${ticketId}/replies`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// status: 'OPEN' | 'CLOSED'
const setSupportTicketStatus = (ticketId, status) => api.patch(`${SUPPORT_TICKETS}/${ticketId}/status`, { status });

// ADMIN and SUPPORT users a ticket can be assigned to: [{ userId, name, email }].
const getSupportAssignees = () => api.get('/admin/support/assignees');

// Reassigns the ticket; the backend emails the new assignee. note is optional.
const assignSupportTicket = (ticketId, assigneeId, note) =>
  api.put(`${SUPPORT_TICKETS}/${ticketId}/assignee`, { assigneeId, note });

// downloadUrl comes from the ticket response, e.g. /admin/support/tickets/12/attachments/7.
const downloadSupportAttachment = (downloadUrl) => api.get(downloadUrl, { responseType: 'blob' });

export {
  getSupportSummary,
  getSupportTickets,
  getSupportTicket,
  replySupportTicket,
  setSupportTicketStatus,
  getSupportAssignees,
  assignSupportTicket,
  downloadSupportAttachment,
};
